export default __webpack_public_path__ + "static/perfective-past-5db64fbba07794e9df154c3e42fc51d6.svg";